import URI from 'urijs';

function openUrl(url: string) {
  const navigableUrl = URI(url).protocol() ? url : `http://${url}`;
  window.open(navigableUrl, '_blank');
}

export default openUrl;
